import {useDispatch, useSelector} from 'react-redux';
import {addSlidesAction} from '../../store/actions/edit';
import {isSlideModifiedSelector, selectedSlideSelector} from '../../store/selectors/slide.selectors';
import {useSlideUpdateContext} from '../../ui/context/SetSlideUpdateContext';
import {TEMPLATE} from '../template/types';

const useCreateNewSlide = (): {createNewSlide: (type: TEMPLATE, toEnd?: boolean) => void} => {
    const {setAndSaveSlide} = useSlideUpdateContext();
    const dispatch = useDispatch();

    const slide = useSelector(selectedSlideSelector);
    const modified = useSelector(isSlideModifiedSelector);

    const mutateOnModified = (cb?: () => void): void => {
        if (modified) {
            setAndSaveSlide(slide, {onSuccess: cb});
        } else cb && cb();
    };

    const createNewSlide = (type: TEMPLATE, toEnd?: boolean): void => {
        mutateOnModified(() => {
            dispatch(addSlidesAction(1, false, type, toEnd));
        });
    };

    return {createNewSlide};
};

export default useCreateNewSlide;
